import pagination from "../static/pagination";

export default {
	setFetching: (state, payload) => {
		state.isFetching = payload;
	},
	setLoadMore: (state, payload) => {
		state.isLoadMore = payload;
	},
	setResponse: (state, payload) => {
		state.response = payload;
	},
	setListProvider: (state, payload) => {
		state.listProvider = [];
		payload.forEach((provider) => {
			state.listProvider.push({id: provider.id, text: provider.nama});
		});
	},
	setListOutlet: (state, payload) => {
		state.listOutlet = [];
		payload.forEach((outlet) => {
			state.listOutlet.push({id: outlet.idoutlet, text: outlet.nama});
		});
	},
	setListSettlementEdc: (state, payload) => {
		state.listSettlementEdc = state.listSettlementEdc.concat(payload);
	},
	setCountData: (state, payload) => {
		state.countData = payload
	},
	resetsetListSettlementEdc: (state) => {
		state.listSettlementEdc = []
	},
	resetPagination: (state) => {
		state.pagination = pagination();
	},
	resetResponse: (state) => {
		state.response = {};
	},

	setExporting: (state, payload) => {
		state.exporting = payload;
	},
	setMinimizedExport: (state, payload) => {
		state.minimizedExport = payload;
	},
	setExportProgress: (state, {processed, total}) => {
		state.exportProgress.processed = Number(processed);
		state.exportProgress.total = Number(total);
	},
	setMultipleExport: (state, payload) => {
		state.multipleExport = payload;
	},
	setExportData: (state, payload) => {
		state.exportData = payload;
	},
	setExportDataLength: (state, payload) => {
		state.exportDataLength = payload;
	},

	toogleDisplayCard: (state, payload) => {
		let etIdx = state.displayCard.findIndex((item) => item.id === payload.data.id);
		if (etIdx === -1 && payload.mode === "add") {
			state.displayCard.push(payload.data);
		}

		if (etIdx !== -1 && payload.mode === "remove") {
			state.displayCard.splice(etIdx, 1);
		}
	},
	setLastItemToView: (state, payload) => {
		state.lastItemToView = payload;
	},
	setNextPagination: (state, payload) => {
		state.pagination.length += payload.list.length;
		state.pagination.pageNumber++;
		state.pagination.offset = state.pagination.pageNumber * state.pagination.limit;
	},
	setEndItemOfPage: (state, payload) => {
		state.endItemOfPage = payload;
	},

};
